import { useWindowDimensions } from 'tamagui'
import RenderHtml from 'react-native-render-html'
import { CONTAINER_WIDTH } from './constants'
import { useResolvedColors } from './hooks'

interface IHtmlContentProps {
  html: string
  // Sem aside ao lado (preview de curso do combo) o conteúdo usa o container
  // inteiro.
  fullWidth?: boolean
}

// HTML vindo do produtor: mantém a customização inline do cliente (cores,
// tamanhos) e estiliza só o que o tema legado também estilizava.
export function HtmlContent({ html, fullWidth = false }: IHtmlContentProps) {
  const colors = useResolvedColors()
  const { width } = useWindowDimensions()

  return (
    <RenderHtml
      contentWidth={Math.min(
        width,
        fullWidth ? CONTAINER_WIDTH : CONTAINER_WIDTH - 400,
      )}
      baseStyle={{ color: colors.text, fontSize: 16, lineHeight: 26 }}
      tagsStyles={{
        blockquote: {
          borderLeftWidth: 3,
          borderLeftColor: colors.text,
          paddingLeft: 16,
          marginLeft: 0,
        },
      }}
      source={{ html }}
    />
  )
}
